import { VoidCallback } from '@deqo/foundation';
import React from 'react';
import styled from 'styled-components';
import { TeamWithMembersData } from '../../../../api/ApiTypes';
import { Icon } from '../../../../concepts/resources/Icon';
import { Colors } from '../../../../ui';
import { useOnCreateTeam } from '../../../actions/WorkspaceActions';
import { Flexer } from '../../../dashboard/elements/LayoutElements';
import { TeamListItem } from './TeamListItem';

const TeamListButtonFrame = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    width: 32.5rem;
    min-height: 13rem;
    border: dashed 2px ${Colors.border};
    border-radius: .5rem;
    color: ${Colors.textLighter};
    font-size: 1.25rem;
    svg {
        width: 1.5rem;
        height: 1.5rem;
    }

    &:hover {
        cursor: pointer;
        background: ${Colors.hover};
    }
    &:active {
        background: ${Colors.active};
    }
`;

const CreateTeamItemButton = ({ onAction }: { onAction: VoidCallback }) => {
    return <TeamListButtonFrame onClick={onAction}>
        <Icon src="deqo://icons/hero/plus" />
        Create Team
    </TeamListButtonFrame>;
};

export const TeamListView = ({ items }: { items: TeamWithMembersData[] }) => {

    const { onCreateWorkspace } = useOnCreateTeam();

    return <Flexer flex="row" gap="1" wrap="wrap">
        {items.map(x =>
            <TeamListItem key={x.id} team={x} />
        )}
        {items.length === 0 && <CreateTeamItemButton onAction={onCreateWorkspace} />}
    </Flexer>;
};

